module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Plataforma.af4058e8.png";